/**
 * After Boost ATC (homepage/collection/PDP), refresh Dawn cart-drawer + badge and open it.
 * Boost's own modal cart stays inactive; Dawn is the only cart UI.
 */
(function () {
  const ATC_SELECTOR = [
    '.boost-sd__button--select-option',
    '.boost-sd__button--purchase',
    '.boost-sd__button--preorder',
    '.boost-sd__button--add-to-cart',
  ].join(', ');

  const ADD_DEDUP_MS = 500;
  const FALLBACK_MS = 1500;
  const GIVE_UP_MS = 8000;

  let expectAdd = false;
  let pendingButton = null;
  let refreshInFlight = false;
  let fallbackTimer = null;
  let giveUpTimer = null;
  let atcClickId = 0;
  let cartAddInflight = 0;

  const recentAdds = new Map();

  function shopRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }

  function isCartAddUrl(url) {
    try {
      const path = typeof url === 'string' ? url : String(url);
      return /\/cart\/add(\.js)?(\?|$)/i.test(path);
    } catch (e) {
      return false;
    }
  }

  function requestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function clearBoostLoading(btn) {
    if (!btn) return;
    btn.classList.remove(
      'boost-sd__button--loading',
      'boost-sd__button--disabled',
      'loading',
      'is-loading',
      'disabled'
    );
    btn.removeAttribute('disabled');
    btn.disabled = false;
    const label = btn.querySelector('.boost-sd__button-text, span');
    if (label && /adding/i.test(label.textContent || '') && btn.__artikaOriginalLabel != null) {
      label.textContent = btn.__artikaOriginalLabel;
      delete btn.__artikaOriginalLabel;
    }
  }

  function getSectionInnerHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function clearAddTimers() {
    if (fallbackTimer) {
      clearTimeout(fallbackTimer);
      fallbackTimer = null;
    }
    if (giveUpTimer) {
      clearTimeout(giveUpTimer);
      giveUpTimer = null;
    }
  }

  async function refreshAndOpen() {
    if (refreshInFlight) return;
    refreshInFlight = true;
    clearAddTimers();

    try {
      const root = shopRoot();
      const res = await fetch(`${root}?sections=cart-drawer,cart-icon-bubble`);
      if (!res.ok) {
        throw new Error(`Cart refresh failed (${res.status})`);
      }
      const sections = await res.json();

      if (sections['cart-drawer']) {
        const cartDrawerHost = document.querySelector('cart-drawer');
        const cartDrawerEl = document.getElementById('CartDrawer');
        if (cartDrawerHost && cartDrawerEl) {
          cartDrawerEl.innerHTML = getSectionInnerHTML(sections['cart-drawer'], '#CartDrawer');
          cartDrawerHost.classList.remove('is-empty');
          const overlay = cartDrawerHost.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', cartDrawerHost.close.bind(cartDrawerHost));
          }
          if (typeof cartDrawerHost.open === 'function') {
            const cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon && typeof cartDrawerHost.setActiveElement === 'function') {
              cartDrawerHost.setActiveElement(cartIcon);
            }
            cartDrawerHost.open(cartIcon || undefined);
          } else {
            cartDrawerHost.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
          }
        }
      }

      if (sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const fromWrapper = getSectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
          bubble.innerHTML = fromWrapper || sections['cart-icon-bubble'];
        }
      }
    } catch (err) {
      console.error('[ArtikaBoostDawnCart] refresh failed', err);
    } finally {
      clearBoostLoading(pendingButton);
      refreshInFlight = false;
      expectAdd = false;
      pendingButton = null;
    }
  }

  async function fallbackRefreshIfCartGrew(baselineCount, clickId) {
    if (!expectAdd || clickId !== atcClickId) return;
    try {
      const cart = await fetch(`${shopRoot()}cart.js`).then((r) => r.json());
      if (clickId !== atcClickId || !expectAdd) return;
      if (typeof cart.item_count === 'number' && cart.item_count > baselineCount) {
        await refreshAndOpen();
        return;
      }
    } catch (e) {
      /* ignore */
    }
    /* A cold /cart/add.js can still be in flight after FALLBACK_MS. Leave
       expectAdd set so the success handler opens the drawer when it finishes. */
    if (clickId === atcClickId && cartAddInflight === 0 && !refreshInFlight) {
      expectAdd = false;
      pendingButton = null;
    }
  }

  function markAtcClick(btn) {
    const label = btn.querySelector('.boost-sd__button-text, span');
    if (label) btn.__artikaOriginalLabel = label.textContent;
    pendingButton = btn;
    expectAdd = true;
    const clickId = ++atcClickId;
    clearAddTimers();

    let baseline = 0;
    const bubbleCount = document.querySelector('.cart-count-bubble [aria-hidden="true"]');
    if (bubbleCount && bubbleCount.textContent) {
      baseline = parseInt(bubbleCount.textContent, 10) || 0;
    }

    fallbackTimer = setTimeout(() => {
      fallbackRefreshIfCartGrew(baseline, clickId);
    }, FALLBACK_MS);
    let giveUpWaits = 0;
    giveUpTimer = setTimeout(function giveUp() {
      if (clickId !== atcClickId) return;
      if (cartAddInflight > 0 && giveUpWaits < 8) {
        giveUpWaits += 1;
        giveUpTimer = setTimeout(giveUp, 1000);
        return;
      }
      expectAdd = false;
      pendingButton = null;
    }, GIVE_UP_MS);
  }

  function onCartAddSuccess() {
    if (!expectAdd) return;
    clearAddTimers();
    refreshAndOpen();
  }

  function beginCartAdd() {
    cartAddInflight += 1;
  }

  function endCartAdd() {
    cartAddInflight = Math.max(0, cartAddInflight - 1);
  }

  function dedupeKey(url, init, input) {
    let body = '';
    if (init && init.body != null) {
      body = typeof init.body === 'string' ? init.body : String(init.body);
    } else if (input && typeof Request !== 'undefined' && input instanceof Request) {
      /* body may be locked; url+method is enough with short window */
      body = '';
    }
    return `${url}::${body}`;
  }

  function installFetchWrapper() {
    if (window.__artikaBoostDawnFetchWrapped) return;
    window.__artikaBoostDawnFetchWrapped = true;

    const originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      const url = requestUrl(input);
      const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();

      if (method === 'POST' && isCartAddUrl(url)) {
        const key = dedupeKey(url, init, input);
        const now = Date.now();
        const prior = recentAdds.get(key);

        if (prior && now - prior.at < ADD_DEDUP_MS && prior.promise) {
          return prior.promise.then((response) => response.clone());
        }

        beginCartAdd();
        const promise = originalFetch(input, init)
          .then((response) => {
            if (response.ok) onCartAddSuccess();
            return response;
          })
          .finally(endCartAdd);

        recentAdds.set(key, { at: now, promise: promise.then((r) => r.clone()) });
        setTimeout(() => {
          const entry = recentAdds.get(key);
          if (entry && entry.at === now) recentAdds.delete(key);
        }, ADD_DEDUP_MS + 50);

        return promise;
      }

      return originalFetch(input, init);
    };
  }

  function installXhrWrapper() {
    if (window.__artikaBoostDawnXhrWrapped) return;
    window.__artikaBoostDawnXhrWrapped = true;

    const xhrOpen = XMLHttpRequest.prototype.open;
    const xhrSend = XMLHttpRequest.prototype.send;
    const inflight = new Map();

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__artikaMethod = method;
      this.__artikaUrl = url;
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      const method = (this.__artikaMethod || 'GET').toUpperCase();
      const url = this.__artikaUrl || '';

      if (method === 'POST' && isCartAddUrl(url)) {
        const key = `${url}::${body == null ? '' : String(body)}`;
        const now = Date.now();
        const prior = inflight.get(key);

        if (prior && now - prior.at < ADD_DEDUP_MS) {
          this.abort();
          return;
        }

        inflight.set(key, { at: now });
        beginCartAdd();
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) onCartAddSuccess();
        }, { once: true });
        this.addEventListener('loadend', endCartAdd, { once: true });
        setTimeout(() => {
          const entry = inflight.get(key);
          if (entry && entry.at === now) inflight.delete(key);
        }, ADD_DEDUP_MS + 50);
      }

      return xhrSend.apply(this, arguments);
    };
  }

  document.addEventListener(
    'click',
    function (event) {
      const btn = event.target.closest(ATC_SELECTOR);
      if (!btn) return;
      markAtcClick(btn);
    },
    true
  );

  installFetchWrapper();
  installXhrWrapper();

  window.ArtikaBoostDawnCart = {
    refresh: refreshAndOpen,
  };
})();
